import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from 'src/app/shared/components';
import { Beneficiaria } from '../beneficiaria.model';
import { BeneficiariaService } from '../beneficiaria.service';
import { catchErr } from 'src/app/shared/utils';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
    selector: 'app-form-beneficiaria-coligada',
    templateUrl: './form-beneficiaria-coligada.component.html',
    styleUrls: ['./form-beneficiaria-coligada.component.css'],
    standalone: false
})
export class FormBeneficiariaColigadaComponent implements OnInit {

  loading: any = { main: false, save: false, beneficiarias: false };
  breadcrumb: Breadcrumb[];

  beneficiaria: Beneficiaria;
  beneficiarias: Beneficiaria[];

  constructor(
    private beneficiariaService: BeneficiariaService,
	  private snackBar: MatSnackBar,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loading.beneficiarias = true;
    this.beneficiariaService.getAll<Beneficiaria>().subscribe({
      next: (res) => {
        this.beneficiarias = res.data.filter(b => !b.coligadaNovacap);
      }, error: (err) => catchErr(err, this.snackBar)
    }).add(() => this.loading.beneficiarias = false);
    
  }

  compareWith(item: Beneficiaria, selected: Beneficiaria) {
	return item.id == selected.id
  }

  setBeneficiaria(beneficiaria: Beneficiaria) { 
    this.beneficiaria = beneficiaria;
  }

  searchFn(term: any, item: any) {
      term = term.toLocaleLowerCase();
      return item.nome.toLocaleLowerCase().indexOf(term) > -1          
  }

  save() {
    this.loading.save = true;
    this.beneficiariaService.update(this.beneficiaria.id, { coligadaNovacap: true }).subscribe({
      next: () => {
        this.snackBar.open('Beneficiária frota Novacap incluída com sucesso!', 'Fechar', { duration: 3000 });
        this.loading.save = false;
        this.router.navigateByUrl('/configuracoes/gerir-coligadas-novacap');
      },
      error: (err) => {
        catchErr(err, this.snackBar);
        this.loading.save = false;
      }
    });
    
  }
}
